module.exports = __webpack_public_path__ + "files/14142ab49bf4229be56a807bfcc944cb.png";